import { general } from './general';
import { detailed } from './detailed';

export const stats = {
  namespaced: true,
  modules: {
    general,
    detailed
  }
};
